import { useState } from 'react';

const useHashFile = () => {
  const [isHashing, setIsHashing] = useState(false);

  const hashFile = async (file) => {
    setIsHashing(true);
    try {
      const arrayBuffer = await file.arrayBuffer();
      const hashBuffer = await crypto.subtle.digest('SHA-256', arrayBuffer);
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      const hashHex = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
      setIsHashing(false);
      return hashHex;
    } catch (error) {
      setIsHashing(false);
      throw error;
    }
  };

  return { hashFile, isHashing };
};

export default useHashFile;
